<template>
  <div
    class="yx-predicted-page main-layout predicted-item-page"
    v-loading="handleLoading"
  >
    <el-card shadow="never" class="box-form box-inner box-bg">
      <c-title slot="header" title="乘车优惠区间"></c-title>
      <div class="pb90">
        <div class="div-scroll">
          <el-form
            size="small"
            :model="handleData"
            ref="cForm"
            :rules="formRules"
            label-width="180px"
            style="width: 60%; margin: 0 auto; padding-top: 40px"
            :disabled="disabled"
          >
            <div
              class="tips-container"
              style="padding-bottom: 20px; margin-left: 80px"
            >
              <div class="tips">
                <div class="title">
                  <i class="el-icon-info"></i><span>温馨提示</span>
                </div>
                <p>1、优惠区间是指符合购买学生优惠火车票条件的学生，购买学生票时，<b style="color: red">家庭居住地(父亲或母亲之中任何一方居住地)和
                  学校所在地不在同一城市，在优惠乘车区间之内，且优惠乘车区间限于家庭至院校之间</b>。详情可咨询：
                  <a href="https://kyfw.12306.cn/otn/gonggao/student.html">https://kyfw.12306.cn/otn/gonggao/student.html</a>
                </p>
                <p>2、按自身实际情况填写乘车优惠区间；</p>
                <p>3、<b style="color: red">起点站均为武汉市内，仅开放武汉火车站、汉口火车站、武昌火车站</b>，如不需乘车优惠，起点站、终点站均选择“/”即可。</p>
              </div>
            </div>
            <el-form-item label="家庭所在地">
              <el-input
                      v-model="studentInfo.addressAreaName"
                      :disabled="true">
              </el-input>
            </el-form-item>
            <el-form-item label="起点站" prop="fromStation">
              <el-select
                v-model="handleData.fromStation"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in fromStationOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="终点站" prop="fromStation">
              <el-select
                v-model="handleData.toStation"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in toStationOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label-width="0">
              <div style="text-align: center; padding-top: 20px">
                <el-button
                  type="primary"
                  class="leave-btn"
                  @click="submit"
                  :disabled="disabled"
                  >提交</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import MHandle from "@/mixins/MHandle.js";
import { mapState } from "vuex";
let mHandle = MHandle({
  handleGetPath: "",
  handleGetPathNoparam: "/welcome-forecast/travel/range/myInfo",
  handleInsertPath: "/welcome-forecast/travel/range/save",
  handleUpdatePath: "/welcome-forecast/travel/range/update",
  handleDownLoadPath: "",
  handleData: {},
});

export default {
  mixins: [mHandle],
  data() {
    return {
      token: "",
      formRules: {
        fromStation: [
          {
            required: true,
            trigger: "blur",
            message: "请选择起点站",
          },
        ],
        toStation: [
          {
            required: true,
            trigger: "blur",
            message: "请输入终点站",
          },
        ],
      },
      studentId: "",
      forecastLinkId: "",
      fromStationOptions: [
        { name: "/" },
        { name: "武汉站" },
        { name: "汉口站" },
        { name: "武昌站" },
      ],
      toStationOptions: [],
      studentInfo:{}
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
    disabled() {
      let status = this.$route.params.status;
      return status == 2 ? true : false;
    },
  },
  created() {
    this.studentId = JSON.parse(localStorage.getItem("userInfo")).studentId;
    this.forecastLinkId = this.$route.params.id;
    this.getFromStation();
    // this.getToStation();
    this.getStudentInfo();
  },
  mounted() {
    this.getTravelInfo(); //查询个人信息
  },
  methods: {
    //查询学生基本信息
    getStudentInfo() {
      this.$http.get("/account/base/student/myInfo")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.studentInfo = res.data;
          }
        })
    },
    //查询起始站
    getFromStation() {
      let params = { siteType: 1 };
      this.$http
        .get("/account/train-station-info/list", { params })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.toStationOptions = res.data;
            this.toStationOptions.unshift({ name: "武汉站" });
            this.toStationOptions.unshift({ name: "/" });
            // console.log(this.fromStationOptions)
          }
        });
    },
    //查询终点站
    getToStation() {
      this.$http.get("/account/train-station-info/list").then((res) => {
        if (res.code == this.SUCCESS_CODE) {
          this.toStationOptions = res.data;
        }
      });
    },
    //查询起始站
    getTrainInfo() {
      this.$http.get("/account/train-station-info/list").then((res) => {
        if (res.code == this.SUCCESS_CODE) {
          this.fromStationOptions = res.data;
          console.log(this.fromStationOptions);
        }
      });
    },
    getSysAreaList() {
      this.$http
        .get("/account/sys-area/getSysAreaList")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.sysAreaOptions = res.data[0].sysAreaLists;
            console.log(this.sysAreaOptions);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 获取学生到校信息
    getTravelInfo() {
      this.handleLoading = true;
      this.$http.get("/welcome-forecast/travel/range/myInfo").then((res) => {
        // console.log(res);
        if (res.code == this.SUCCESS_CODE) {
          if (res.data) this.handleData = res.data;
        } else {
          this.$message.error(`${res.msg}`);
        }
        this.handleLoading = false;
      }).catch(err => {
        this.handleLoading = false;
      })
    },
    handleBeforeFn(data) {
      data.forecastLinkId = this.forecastLinkId;
      data.studentId = this.studentId;
    },
    submit() {
      this.$refs["cForm"].validate((valid) => {
        if (valid) {
          this.$confirm("请确认无误后提交，是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            if (this.handleData.id) {
              this.handleUpdate();
            } else {
              this.handleInsert();
            }
          });
        }
      });
    },
    handleAfterFn() {
      this.isSubmit = false;
      // this.$router.go(0);
      this.$router.replace("/welcome/student/predicted");
    },
  },
};
</script>

